import React from 'react';

function A11yStatement() {
	return (
		<main id="main" className="sectionOne">
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-8">
						<div className="text">
							<h1 className="heading-large">Accessibility Statement</h1>
							<div>
								<p>This accessibility statement applies to this Adult Social Care referral form.</p>

								<p>This website is run by Leeds City Council. We want as many people as possible to be able to use this website. For example, that means you should be able to:</p>

								<p>change colours, contrast levels and fonts</p>

								<p>zoom in up to 300% without the text spilling off the screen</p>

								<p>navigate most of the website using just a keyboard</p>

								<p>navigate most of the website using speech recognition software</p>

								<p>listen to most of the website using a screen reader (including the most recent versions of JAWS, NVDA and VoiceOver)</p>

								<p>We’ve also made the website text as simple as possible to understand.</p>

								<p>AbilityNet has advice on making your device easier to use if you have a disability.</p>

								<h2>Feedback and contact information</h2>
								<p>If you need information on this website in a different format email webmaster@leeds.gov.uk and tell us:</p>

								<p>the web address (URL) of the content</p>

								<p>your name and email address</p>

								<p>the format you need, for example, audio, braille, BSL or large print</p>

								<h2>Reporting accessibility problems with this website</h2>
								<p>We’re always looking to improve the accessibility of this website. If you find any problems not listed on this page or think we’re not meeting accessibility requirements, contact: <a href="mailto:webmaster@leeds.gov.uk">webmaster@leeds.gov.uk</a>.</p>

								<h2>Enforcement procedure</h2>
								<p>The Equality and Human Rights Commission (EHRC) is responsible for enforcing the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018 (the ‘accessibility regulations’). If you’re not happy with how we respond to your complaint, contact the Equality Advisory and Support Service (EASS).</p>

								<h2>Technical information about this website’s accessibility</h2>
								<p>Leeds City Council is committed to making its website accessible, in accordance with the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018.</p>

								<h2>Compliance status</h2>
								<p>This website is fully compliant with the Web Content Accessibility Guidelines version 2.1 AA standard.</p>

								<h2>Disproportionate burden</h2>
								<p>N/A</p>

								<h2>Content that’s not within the scope of the accessibility regulations</h2>
								<p>N/A</p>

								<h2>Preparation of this accessibility statement</h2>
								<p>This statement was prepared on 28/04/23. It was last reviewed on 28/04/23.</p>

								<p>This website was last tested on 28/04/23. The test was carried out by Leeds City Council.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
};
export default A11yStatement;
